import React, { FC, ReactNode } from 'react';
import clsx from 'clsx';

type Props = {
  children: ReactNode;
  columns: number;
  gap: number;
  className?: string;
  style?: React.CSSProperties;
};

const BlockGrid: FC<Props> = ({ children, style, columns, className, gap }) => {
  const childrenArray = React.Children.toArray(children);
  const rows = [];

  for (let i = 0; i < childrenArray.length; i += columns) {
    rows.push(childrenArray.slice(i, i + columns));
  }

  return (
    <div className={clsx('tw-block', className)} style={style}>
      {rows.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className="tw-block tw-break-inside-avoid"
          style={{
            marginBottom: rowIndex < rows.length - 1 ? gap : 0,
          }}
        >
          <div className="tw-flex" style={{ gap }}>
            {row.map((child, colIndex) => (
              <div
                key={colIndex}
                style={{
                  flex: `1 1 ${100 / columns}%`,
                  maxWidth: `${100 / columns}%`,
                }}
              >
                {child}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlockGrid;
